import { useMutation, UseMutationOptions } from '@tanstack/react-query'
import { FeedbackSubmissionRequest } from 'admin/template-elements/edit-list/types'
import { submitLiveblocksFeedback } from '@global/api/liveblocks'

export const useSubmitLiveblocksFeedback = (
  options: UseMutationOptions<never, Error, FeedbackSubmissionRequest> = {},
) =>
  useMutation({
    mutationFn: request => submitLiveblocksFeedback(request),
    ...options,
  })
